import settings from "../../../../RestAPI/whitelabel.settings.json";
import { getTypedKeys } from "./functions/get-typed-keys.function";

export const appSettingsKeys = getTypedKeys(settings);
